import { ImportDataInvestmentsBasicQuery } from '@/__generated__/graphql';
import Button from '@/components/basicComponents/button';
import Select from '@/components/basicComponents/select';
import { createSimpleSelectOption } from '@/components/basicComponents/select/utils';
import { ISeriesCodesTableData } from '@/components/settings-page/importData/types';
import {
  MobileRow,
  MobileRowTitle,
  MobileRowValue,
  MobileTableRowWrap,
  MobileTableWrapper,
  NoResults
} from '@/components/table/mobileTable/mobileTable';
import styled from 'styled-components';
import { RowStatus } from '../../entityCodes/table/cell/rowStatus';
import { columns } from '../constants';

interface MobileTableProps {
  tableData: ISeriesCodesTableData[];
  investmentList: ImportDataInvestmentsBasicQuery['Investments']['data'];
  investmentListLoading: boolean;
  handleChangeAssignment: (investmentName: string, seriesCode: string) => void;
  resetAssignment: (seriesCode: string) => void;
}

const MobileTable = ({ tableData, investmentList, investmentListLoading, handleChangeAssignment, resetAssignment }: MobileTableProps) => {
  const TableRow = ({ el }: { el: ISeriesCodesTableData }) => {
    return (
      <MobileTableRowWrap key={el.id}>
        <MobileRow>
          <MobileRowTitle>{columns[0].title}</MobileRowTitle>
          <MobileRowValue>{el.investmentCode}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{columns[1].title}</MobileRowTitle>
          <MobileRowValue>{el.seriesName}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{columns[2].title}</MobileRowTitle>
          <MobileRowValue>
            {el.seriesStatus === 'Assigned' ? (
              <>{el.seriesAssignment}</>
            ) : (
              <Select
                value={el.seriesAssignment}
                previewValue={el.seriesAssignment === 'Select A Strategy' ? '' : el.seriesAssignment}
                setValue={(value) => handleChangeAssignment(value, el.investmentCode)}
                options={investmentList.map((investment) => createSimpleSelectOption(investment.id, investment.name))}
                loading={investmentListLoading}
                size="md"
                additionalOption={
                  <ClearSelectionButtonWrapper>
                    <Button
                      size="sm"
                      onClick={() => resetAssignment(el.investmentCode)}
                      styleType={el.seriesAssignment === 'Select A Strategy' ? 'disabled' : 'outline'}
                    >
                      Clear Selection
                    </Button>
                  </ClearSelectionButtonWrapper>
                }
                withSearch
              />
            )}
          </MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{columns[3].title}</MobileRowTitle>
          <MobileRowValue>
            <RowStatus status={el.seriesStatus} />
          </MobileRowValue>
        </MobileRow>
      </MobileTableRowWrap>
    );
  };

  return (
    <MobileTableWrapper>
      {tableData.length ? (
        tableData.map((el: ISeriesCodesTableData, index: number) => {
          return <TableRow el={el} key={index} />;
        })
      ) : (
        <NoResults>No Results</NoResults>
      )}
    </MobileTableWrapper>
  );
};

export default MobileTable;

const ClearSelectionButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;
